import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "small striped toggle no-underline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Local "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " First Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Last Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-2" }, " Email Address "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Title "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Days to Expiration "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-1" }, " Type "),
    /*#__PURE__*/_createElementVNode("th", { class: "col-md-2" }, " Account actions ")
  ])
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-md-1" }
const _hoisted_5 = { class: "col-md-1" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = { class: "col-md-1" }
const _hoisted_9 = { class: "col-md-1" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = {
  key: 0,
  class: "tooltip-wrapper",
  "data-tooltip": "Activate User"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "tooltip-wrapper",
  "data-tooltip": "Deactivate User"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_17 = {
  key: 2,
  class: "tooltip-wrapper",
  "data-tooltip": "Remove Admin Role"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 3,
  class: "tooltip-wrapper",
  "data-tooltip": "Make User Admin"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_22 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Reset PIN"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_25 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Masquerade"
}
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locals, (local) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "large",
            key: local.LocalID
          }, [
            _createElementVNode("td", {
              class: "col-md-1 plan-modal",
              onClick: ($event: any) => (_ctx.openModal('edit-user', 'Locals', 'plan-profile plan-tables', null, { UserID: local.UserID }))
            }, _toDisplayString(local.OrgName), 9, _hoisted_3),
            _createElementVNode("td", _hoisted_4, _toDisplayString(local.FirstName), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(local.LastName), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(local.Email), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(local.Title), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(local.DaysToExpiration), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(local.Role), 1),
            _createElementVNode("td", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (local.Inactive == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.activate(local.UserID)),
                        class: "plan-modal fs-xs iatse-icon-noun-reset"
                      }, null, 8, _hoisted_13)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.deactivate(local.UserID)),
                        class: "plan-modal iatse-icon-deactivate-user"
                      }, null, 8, _hoisted_15)
                    ])),
                _hoisted_16,
                (local.Role == 'Admin')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.changeRole(local.UserID)),
                        class: "plan-modal iatse-icon-person-remove"
                      }, null, 8, _hoisted_18)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createElementVNode("i", {
                        onClick: ($event: any) => (_ctx.changeRole(local.UserID)),
                        class: "plan-modal iatse-icon-person"
                      }, null, 8, _hoisted_20)
                    ])),
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (_ctx.resetPin(local.UserID)),
                    class: _normalizeClass(['plan-modal', 'iatse-icon-reset', { 'icon-green': local?.DaysToExpiration === 0 }])
                  }, null, 10, _hoisted_23)
                ]),
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (_ctx.loginAsUser(local.UserID)),
                    class: "plan-modal iatse-icon-noun-login"
                  }, null, 8, _hoisted_26)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}